export default __webpack_public_path__ + "static/media/delete.376f0c17.svg";